import { Component } from "@angular/core";
import { SelectWindow, ModalService } from "@xo/client-common";
import { Type3Number, Type3NumberType } from "./Type3Number";

@Component({
    selector: "spec-app-type3-number-select",
    templateUrl: "./type3Number.select.html",
    styleUrls: ["./type3Number.select.scss"]
})
export class Type3NumberSelect extends SelectWindow<Type3Number> {

    constructor(modalService: ModalService) {
        super(modalService, Type3NumberType, "simpleField");
    }
}
